var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-dropdown-wrapper", {
    ref: "dropdownWrapper",
    staticClass: "el-select dsf-area-cascader",
    attrs: {
      disabled: _vm.disabled,
      "max-height": "295px",
      height: "295px",
      lazy: "",
    },
    on: { "visible-change": _vm.visibleChange },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function () {
            return [
              _c(
                "el-input-pro",
                {
                  ref: "reference",
                  class: { "is-focus": _vm.visible },
                  attrs: {
                    value: _vm.selectedText,
                    placeholder: _vm.placeholder,
                    name: _vm.name,
                    autocomplete: _vm.autocomplete,
                    disabled: _vm.disabled,
                    "validate-event": false,
                    readonly: "",
                  },
                  on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
                  nativeOn: {
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.visible = false
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        _vm.visible = false
                      },
                    ],
                    mouseenter: function ($event) {
                      _vm.inputHovering = true
                    },
                    mouseleave: function ($event) {
                      _vm.inputHovering = false
                    },
                  },
                },
                [
                  _vm.$slots.prefix
                    ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
                    : _vm._e(),
                  _c("template", { slot: "suffix" }, [
                    _vm.inputHovering && _vm.showCloseCopy
                      ? _c("i", {
                          staticClass:
                            "el-select__caret el-input__icon el-icon-circle-close",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleClearClick.apply(null, arguments)
                            },
                          },
                        })
                      : _vm._e(),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.inputHovering || !_vm.showCloseCopy,
                          expression: "!inputHovering || !showCloseCopy",
                        },
                      ],
                      class: [
                        "el-select__caret",
                        "el-input__icon",
                        "el-icon-" + _vm.iconClass,
                      ],
                    }),
                  ]),
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "dropdown",
          fn: function () {
            return [
              _c("dsf-area-cascader-panel", {
                ref: "panel",
                attrs: {
                  "super-code": _vm.realSuperCode,
                  accuracy: _vm.accuracy,
                  "check-strictly": _vm.checkStrictly,
                  "options-text-field": _vm.optionsTextField,
                  "selected-text-field": _vm.selectedTextField,
                },
                on: { change: _vm.handleChange },
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }